import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchInsertEthicsTeamGroupDetails } from "./helpAndAssistantApi";
import swal from 'sweetalert';
export interface insertEthicsTeamGroupDetailsState {
  insertEthicsTeamGroupDetails: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: insertEthicsTeamGroupDetailsState = {
  insertEthicsTeamGroupDetails: [],
  status: "idle",
};

export const GetinsertEthicsTeamGroupDetails = createAsyncThunk(
  "insertEthicsTeamGroupDetails",
  async (data: any) => {
    const response = await fetchInsertEthicsTeamGroupDetails(data);
    return response;
  }
);

export const insertEthicsTeamGroupDetailsSlice = createSlice({
  name: "insertEthicsTeamGroupDetails",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetinsertEthicsTeamGroupDetails.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetinsertEthicsTeamGroupDetails.rejected, (state, action) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetinsertEthicsTeamGroupDetails.fulfilled, (state, action) => {
        state.status = "success";
        state.insertEthicsTeamGroupDetails = action.payload;
        swal("Record saved success!",  "success");
      });
  },
});

export const {} = insertEthicsTeamGroupDetailsSlice.actions;

export const selectinsertEthicsTeamGroupDetails = (state: RootState) => {
  return state.InsertEthicsTeamGroupDetails.insertEthicsTeamGroupDetails;
};

export default insertEthicsTeamGroupDetailsSlice.reducer;
